'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combine = combine;
exports.array = array;
exports.validatorFromFunction = validatorFromFunction;
exports.optional = optional;

var _index = require('./index');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function combine() /* validators */{
  var _arguments = arguments;

  return function (value) {
    for (var i = 0; i < _arguments.length; i++) {
      var result = _arguments[i](value);
      if (result) {
        return result;
      }
    }

    return null;
  };
}

function array(validationSpec) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$min = _ref.min,
      min = _ref$min === undefined ? 0 : _ref$min;

  return function (valueOrUndefined) {
    var value = valueOrUndefined || [];
    var normalizedValue = value.concat(new Array(Math.max(0, min - value.length)).fill({}));
    return normalizedValue.map(function (v) {
      return (0, _index.validate)(v, validationSpec);
    });
  };
}

function validatorFromFunction(validationFunction, undefinedIsError) {
  return function (params) {
    var _this = this;

    var argumentsAsArray = [].slice.apply(arguments);
    return function (message) {
      return function (value) {
        if (undefinedIsError && value === undefined) {
          return message;
        }

        return validationFunction.apply(_this, [value].concat(_toConsumableArray(argumentsAsArray))) ? null : message;
      };
    };
  };
}

function optional(inner) {
  return function (value) {
    if (value === undefined) {
      return null;
    }

    return inner(value);
  };
}